import { Routes } from '@angular/router';
import { environment } from '../environments/environment';

export const routes: Routes = [
  {
    path: 'products/:productId',
    // `productId` (route param) and `liftCapacityBaseUrl` (route data) are bound
    // to the component inputs via `withComponentInputBinding()`.
    data: { liftCapacityBaseUrl: environment.liftCapacityUrl },
    loadComponent: () =>
      import('@comparison').then(m => m.ProductComparisonComponent),
  },
];
